/*
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2025, Zumper
 */

import type { RawListable } from '@zcode/state-type'

export const getRawListableCardbackQuery = (listables?: readonly RawListable[]) => {
  const rawListablesCardbackQuery: { [key: string]: { pl_id?: number; pb_id?: number } } = {}
  if (listables?.length) {
    for (let i = 0; i < listables.length; i++) {
      const listable = listables[i]
      if (listable.pb_id) {
        rawListablesCardbackQuery[`${listable.group_id}`] = { pb_id: listable.pb_id }
      } else if (listable.pl_id) {
        rawListablesCardbackQuery[`${listable.group_id}`] = { pl_id: listable.pl_id }
      } else {
        rawListablesCardbackQuery[`${listable.group_id}`] = {}
      }
    }
  }

  return rawListablesCardbackQuery
}
